import { createSelector } from 'reselect'

import { CompareVehicle } from '@cinch/oxd-redux/compare/src/interfaces'

const getVehicles = (state: any) => state.compare.vehicles || []

export default createSelector(getVehicles, (vehicles: CompareVehicle[]) => vehicles)
